import { get } from "lodash-es";

export default {
  data() {
    return {
      menus: [],
      myMenu: [],
      colour: "",
      routeViewKey: {
        path: get(this, "$route.fullPath", ""),
        iteration: 0,
      },
      itemsLanguage: [
        {
          name: "English",
          isSelected: false,
          value: "en",
        },
        {
          name: "Bahasa Indonesia",
          isSelected: false,
          value: "id",
        },
        // {
        //   name: "Tiếng Việt",
        //   isSelected: false,
        //   value: "vi",
        // },
      ],
    };
  },
};
